export default ({ children }) => (
  <p className="lead text-center mv-3">{children}</p>
);
